import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { isMobile } from '../utils';

export default function useDatePicker() {
  return isMobile ? MobileDatePicker : DesktopDatePicker;
}